import {Component, OnInit, OnDestroy} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AngularFireAuth} from 'angularfire2/auth';

import * as firebase from 'firebase'; // TODO: update to only use 'firebase/auth'

import {WindowProvider} from '../../providers/window/window';

import {RegisterStaffPage} from '../../pages/register-staff/register-staff';
import {RegisterRecruiterPage} from '../../pages/register-recruiter/register-recruiter';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit, OnDestroy {
  windowRef: any;
  loginForm: FormGroup;
  verificationForm: FormGroup;
  isConfirmed = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private win: WindowProvider,
    private afAuth: AngularFireAuth,
  ) {
    this.loginForm = this.formBuilder.group({
      cellphone: [''],
    });
    this.verificationForm = this.formBuilder.group({
      verificationCode: [''],
    });
  }

  ngOnInit() {
    const self = this;
    self.windowRef = self.win.windowRef;
    self.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'recaptchaContainer',
    );
    self.windowRef.recaptchaVerifier.render();
  }

  ngOnDestroy() {
    const self = this;
  }

  ionViewDidLoad() {
    // TODO: add analytics
  }

  sendLoginCode() {
    const self = this;
    const appVerfier = self.windowRef.recaptchaVerifier;
    const num = `+27${self.loginForm.controls.cellphone.value}`; // TODO: create a service/method that converts numbers enetered into correct format

    firebase
    .auth()
    .signInWithPhoneNumber(num, appVerfier)
    .then(res => {
      self.windowRef.confirmationResult = res;
      self.isConfirmed = true;
    })
    .catch(err => {
      console.log(err);
    });
  }

  verifyLoginCode() {
    const self = this;
    self.windowRef.confirmationResult
    .confirm(self.verificationForm.controls.verificationCode.value)
    .then(res => {
      console.log(res);
    })
    .catch(err => {
      console.log(err);
    });
  }

  loginWithGoogle() {
    const self = this;
    self.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  loginWithFacebook() {
    const self = this;
    self.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
    console.log('about to login with Facebook');
  }

  openPage(page: string) {
    const self = this;
    console.log(page);
    switch (page) {
      case 'staff': {
        self.navCtrl.push(RegisterStaffPage);
        break;
      }
      case 'recruiter': {
        self.navCtrl.push(RegisterRecruiterPage);
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts